export const INDEX = '/'
export const BLOG = '/blog'
export const COMPARISON = '/comparison'
export const CONTRACT_INSURANCE_NEW = '/contract/:insurance/new'
export const CONTRACT_INSURANCE = '/contract/:insurance'
export const FORM_PZP_CALCULATOR = '/pzp-kalkulacka'
export const FORM_BEST_PZP = '/najlepsie-poistenie-auta-pzp'
export const FORM_CHEAPEST_PZP = '/najlacnejsie-pzp-na-auto'
export const FORM_CAR_INSURANCE = '/zakonna-poistka-auta'
export const FORM_SCOOTER = '/pzp-kolobezky-elektrobicykle'
export const INSURANCE_COMPANIES = '/poistovne'
export const TERMINATION = '/vypoved-pzp'
export const FAQ = '/najcastejsie-kladene-otazky-PZP'
